import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";
import { Dialog, Grid } from "@material-ui/core";

import { fetchPost, fetchGet } from "../../api/fetch";
import { setBreadcrumb } from "../../actions/common";
import Barcode from './assets/mdi_barcode_scan.svg';
import MobileCreateOrderRequest from "./MobileCreateOrderRequest";
import MobileVmiZones from "./MobileVmiZones";
import ScanPopup from "./ScanPopup";

const styles = {
  mainContent: {
    width: "calc(100vw - 128px)",
    height: "calc(100vh - 200px)",
    minHeight: 0,
    margin: "24px",
    padding: "24px",
    '@media(max-width: 470px)': {
      margin: "0",
      padding: "22px",
      borderRadius: "0",
      width: "100%",
      height: "100%",
    }
  },
  scanProduct: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    color: "#5f00a0",
    cursor: "pointer",
    "& img": {
      marginRight: "4px",
    },
  },
  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "360px",
    margin: 0,
  },
};

const WMSInventory = (props) => {
  const { classes, dispatch } = props;

  // Dialog Management
  const [scanDialog, setOpenScan] = React.useState(true)
  const [inventoryDialog, setOpenRequest] = React.useState(false)
  const [zoneDialog, setOpenZone] = React.useState(false)

  // Scan Search Management
  const [selectedProductData, setSelectedProductData] = React.useState({})
  const [selectedZoneId, setSelectedZoneId] = React.useState({})

  const [scanError, setScanError] = React.useState("")

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: I18n.get("sidebar_inventory"),
        },
      ])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleBreadcrumbNavigation = zoneId => {
    setSelectedZoneId(zoneId)
    setOpenRequest(false)
    setOpenZone(true)
  }

  const handleScanDialog = scanId => {
    if (scanId > 100000) { // Scan PZI ID - Order Request Dialog

      const body = {
        "description": null,
        "code_product": null,
        "vendor_name": null,
        "ogc": null,
        "category": null,
        "limit": 10,
        "vmi": null,
        "codebin": scanId,
        "pzitbl": true,
      }

      try {
        fetchPost("products/search", body)
          .then(product => {
            console.log(product)
            if (product[0]) {
              if (product[0].order_request_id) {
                fetchGet(`order_request/${product[0].order_request_id}`)
                  .then(orderRequest => {
                    console.log(orderRequest)
                    orderRequest["order_request_id"] = orderRequest["id"]
                    orderRequest["order_request_quantity"] = orderRequest["quantity"]
                    orderRequest["order_request_units"] = orderRequest["unit_of_measurement"]
                    setOpenScan(false)
                    setSelectedProductData({ id: product[0].product_id, orderRequest, zoneId: product[0].zone_id, pziId: scanId })
                    setOpenRequest(true)
                  })

              } else {
                setOpenScan(false)
                setSelectedProductData({ id: product[0].product_id, orderRequest: null, zoneId: product[0].zone_id, pziId: scanId })
                setOpenRequest(true)
              }
            }

          })
          .catch(e => {
            console.error(e)
          })
      } catch (e) {
        console.log(e);
      }

    } else {
      // Scan Zone ID - Zone Navigation Dialog
      setSelectedZoneId(scanId)
      setOpenScan(false)
      setOpenZone(true)
    }
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      className={`mainContent ${classes.mainContent}`}
    >
      <div>
        <div className={classes.scanProduct} onClick={() => setOpenScan(true)}>
          <img src={Barcode} alt="Scan Product" />
        </div>
        <Dialog open={inventoryDialog} fullWidth classes={{ paper: classes.dialogPaper }} onBackdropClick={() => setOpenRequest(false)}>
          <MobileCreateOrderRequest
            setOpenScan={setOpenScan}
            setOpenRequest={setOpenRequest}
            setSelectedProductData={setSelectedProductData}
            productData={selectedProductData}
            handleBreadcrumbNavigation={handleBreadcrumbNavigation}
            inventory={true}
          />
        </Dialog>

        <Dialog open={zoneDialog} fullWidth classes={{ paper: classes.dialogPaper }} onBackdropClick={() => setOpenZone(false)}>
          <MobileVmiZones
            setOpenZone={setOpenZone}
            setOpenRequest={setOpenRequest}
            setSelectedProductData={setSelectedProductData}
            setSelectedZoneId={setSelectedZoneId}
            selectedZoneId={selectedZoneId}
          />
        </Dialog>

        <Dialog open={scanDialog} PaperProps={{ style: { margin: "0" }, }} onBackdropClick={() => setOpenScan(false)}>
          <ScanPopup
            setOpenScan={setOpenScan}
            errorMsg={scanError}
            setScanError={setScanError}
            handleScanDialog={handleScanDialog}
          />
        </Dialog>

      </div>
    </Grid>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(WMSInventory))

);